import { useEffect } from 'react';

function useStyle(url) {
  useEffect(() => {
    const link = document.createElement('link');
    link.href = new URL(url, process.env.PUBLIC_URL).toString();
    link.rel = 'stylesheet';
    link.type = 'text/css';
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, [url]);
}

export default useStyle;
